/**
 * Magna UGC Carousel
 * Handles horizontal scrolling, dot navigation, arrow, and filter pills.
 */
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-magna-ugc-carousel]');

  sections.forEach(function (section) {
    var track = section.querySelector('[data-ugc-track]');
    var dotsContainer = section.querySelector('[data-ugc-dots]');
    var nextBtn = section.querySelector('[data-ugc-next]');
    var pills = section.querySelectorAll('.magna-ugc-carousel__pill');
    var cards = track ? Array.from(track.querySelectorAll('.magna-ugc-carousel__card')) : [];

    if (!track || cards.length === 0) return;

    var currentPage = 0;
    var totalPages = 1;

    function getCardsPerPage() {
      var trackWidth = track.parentElement.offsetWidth;
      var cardEl = cards.find(function (c) { return c.style.display !== 'none'; });
      if (!cardEl) return 1;
      var cardWidth = cardEl.offsetWidth + 20;
      return Math.max(1, Math.floor(trackWidth / cardWidth));
    }

    function getVisibleCards() {
      return cards.filter(function (c) { return c.style.display !== 'none'; });
    }

    function updateDots() {
      if (!dotsContainer) return;
      var visible = getVisibleCards();
      var perPage = getCardsPerPage();
      totalPages = Math.max(1, Math.ceil(visible.length / perPage));

      dotsContainer.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'magna-ugc-carousel__dot' + (i === currentPage ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (page) {
          dot.addEventListener('click', function () { goToPage(page); });
        })(i);
        dotsContainer.appendChild(dot);
      }
    }

    function goToPage(page) {
      var visible = getVisibleCards();
      var perPage = getCardsPerPage();
      totalPages = Math.max(1, Math.ceil(visible.length / perPage));

      currentPage = Math.max(0, Math.min(page, totalPages - 1));

      var cardEl = cards.find(function (c) { return c.style.display !== 'none'; });
      if (!cardEl) return;
      var cardWidth = cardEl.offsetWidth + 20;
      var offset = currentPage * perPage * cardWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';

      var dots = dotsContainer ? dotsContainer.querySelectorAll('.magna-ugc-carousel__dot') : [];
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentPage); });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage + 1 >= totalPages ? 0 : currentPage + 1);
      });
    }

    // Touch/swipe
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) goToPage(currentPage + 1);
        else goToPage(currentPage - 1);
      }
    }, { passive: true });

    // Filter pills
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        var filterTag = (pill.dataset.filter || '').trim();

        cards.forEach(function (card) {
          if (!filterTag) {
            // Empty filter = show all cards
            card.style.display = '';
          } else {
            var cardTags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim().toLowerCase(); });
            var match = cardTags.indexOf(filterTag.toLowerCase()) !== -1;
            card.style.display = match ? '' : 'none';
          }
        });

        currentPage = 0;
        track.style.transform = 'translateX(0)';
        updateDots();
      });
    });

    // Init
    updateDots();

    // Recalc on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateDots();
        goToPage(currentPage);
      }, 200);
    });
  });
});
